type HexagonClusterProps = {
  className?: string;
  fill?: string;
};

const HexagonCluster = ({ className, fill }: HexagonClusterProps) => (
  <svg
    width="35"
    height="34"
    viewBox="0 0 35 34"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      id="Vector"
      d="M17 3.25111V9.74889L11.5022 13L6 9.74889V3.25111L11.5022 0L17 3.25111Z"
      fill={fill}
    />
    <path
      id="Vector_2"
      d="M29 3.25111V9.74889L23.5022 13L18 9.74889V3.25111L23.5022 0L29 3.25111Z"
      fill={fill}
    />
    <path
      id="Vector_3"
      d="M17 24.2511V30.7489L11.5022 34L6 30.7489V24.2511L11.5022 21L17 24.2511Z"
      fill={fill}
    />
    <path
      id="Vector_4"
      d="M29 24.2511V30.7489L23.5022 34L18 30.7489V24.2511L23.5022 21L29 24.2511Z"
      fill={fill}
    />
    <path
      id="Vector_5"
      d="M23 13.7511V20.2489L17.5022 23.5L12 20.2489V13.7511L17.5022 10.5L23 13.7511Z"
      fill={fill}
    />
    <path
      id="Vector_6"
      d="M11 13.7511V20.2489L5.50217 23.5L0 20.2489V13.7511L5.50217 10.5L11 13.7511Z"
      fill={fill}
    />
    <path
      id="Vector_7"
      d="M35 13.7511V20.2489L29.5022 23.5L24 20.2489V13.7511L29.5022 10.5L35 13.7511Z"
      fill={fill}
    />
  </svg>
);

export default HexagonCluster;
